export var cibNintendo = ["32 32", "<path d='M0 0.803h9.469l13.129 21.197v-21.197h9.401v30.395h-9.385l-13.203-21.197v21.197h-9.412v-30.395z'/>"];
